module.exports = __webpack_public_path__ + "media/stylesheets/images/media/advertising_folk_bg-137d065d80ed7c47a3ac631991eedf89.jpg";